// AUTO-GENERATED - DO NOT EDIT!
import gql from "graphql-tag";
import { useMutation, MutationHookOptions } from "@apollo/client";
import { authenticate, authenticateVariables } from "../types/authenticate";

export const useAuthenticateMutation = (
  opts: MutationHookOptions<authenticate, authenticateVariables>
) => {
  return useMutation<authenticate, authenticateVariables>(
    authenticateMutation,
    opts
  );
};

export const authenticateMutation = gql`
  mutation authenticate($email: String!, $password: SensitiveData!) {
    authenticate(email: $email, password: $password) {
      account {
        id
        intercomId
        email
        firstName
        lastName
        intercomUserHash
        patients {
          edges {
            node {
              id
            }
          }
        }
      }
      tokens {
        accessToken
        refreshToken
      }
      errors {
        field
        message
      }
    }
  }
`;
